export const notesConstants = {

    ADD_NOTES_REQUEST: 'ADD_NOTES_REQUEST',
    ADD_NOTES_SUCCESS: 'ADD_NOTES_SUCCESS',
    ADD_NOTES_FAILURE: 'ADD_NOTES_FAILURE',
    ADD_NOTES_CLEAR : "ADD_NOTES_CLEAR",

    GET_NOTES_REQUEST: 'GET_NOTES_REQUEST',
    GET_NOTES_SUCCESS: 'GET_NOTES_SUCCESS',
    GET_NOTES_FAILURE: 'GET_NOTES_FAILURE',

    EDIT_NOTES_STATUS_REQUEST: 'EDIT_NOTES_STATUS_REQUEST',
    EDIT_NOTES_STATUS_SUCCESS: 'EDIT_NOTES_STATUS_SUCCESS',
    EDIT_NOTES_STATUS_FAILURE: 'EDIT_NOTES_STATUS_FAILURE',

}